import { useMemo } from 'react';
import { useUpdateEffect } from 'react-use';

import { Bean, FieldControllerProps, ValidationRules } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';

import { MedicalServicenNameForInvoicing, WithNameForInvoicing } from './nameForInvoicing.types';

const NAME_FOR_INVOICING_MAX_LENGTH = 150;
const t = medicalServiceTranslationKeys.shared.nameForInvoicing.textView;

type MedicalServiceNameForInvoicingFieldProps = Omit<
   FieldControllerProps<
      'nameForInvoicing',
      MedicalServicenNameForInvoicing,
      WithNameForInvoicing,
      'register' | 'setValue' | 'watch' | 'trigger'
   >,
   'required'
> & {
   readonly disabled?: boolean;
};

export const MedicalServiceNameForInvoicingField = (props: MedicalServiceNameForInvoicingFieldProps): JSX.Element => {
   const { name, usingNameAsNameForInvoicing } = props.watch(['name', 'usingNameAsNameForInvoicing']);
   const disabled = props.disabled || usingNameAsNameForInvoicing;

   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: !usingNameAsNameForInvoicing,
         maxLength: usingNameAsNameForInvoicing ? undefined : NAME_FOR_INVOICING_MAX_LENGTH,
      };
   }, [usingNameAsNameForInvoicing]);

   useUpdateEffect(() => {
      if (usingNameAsNameForInvoicing) {
         props.setValue('nameForInvoicing', name);
      }
   }, [name, usingNameAsNameForInvoicing]);

   useUpdateEffect(() => {
      if (!usingNameAsNameForInvoicing) {
         props.trigger('nameForInvoicing');
      }
   }, [usingNameAsNameForInvoicing]);

   return (
      <TextInput
         testId={props.name}
         controller={props.register(props.name, validationRules)}
         defaultValue={props.defaultValue}
         disabled={disabled}
         placeholder={disabled ? t.placeholder.disabled : t.placeholder.default}
      />
   );
};
